import type { AxiosInstance } from 'axios'
import { useMemo } from 'react'
import tcmApiClient from '../../../../services/tcmApiClient'

/**
 * TCM API client — uses RM's dual-gateway `tcmApiClient` (Bearer token from localStorage).
 */
export function useApiClient(): AxiosInstance {
  return useMemo(() => tcmApiClient, [])
}
